import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { StageTaskType } from '@/store/Lifecycle/constants';
import { AutoSaverFormItem } from './AutoSaverFormItem';
import { getTaskFieldMetadata } from './constants';
import { useTask } from './Provider';

export const BooleanField = observer(() => {
  const { t } = useTranslation();
  const task = useTask<StageTaskType.Boolean>();
  const { name, value, isSaving, help, validateStatus, isReadOnly, required } = getTaskFieldMetadata(task);

  return (
    <AutoSaverFormItem
      name={name}
      initialValue={value}
      valuePropName="checked"
      className="stage-task-input-field"
      help={t(help)}
      validateStatus={validateStatus}
      required={required}
      saveOnChange
    >
      <Switch className="stage-task-input" checked={!!value} disabled={isReadOnly} loading={isSaving} />
    </AutoSaverFormItem>
  );
});
